import React from 'react';

import { IconCardProps } from './IconCard.types';

import styles from './IconCard.module.scss';

export const IconCard = ({
  contentBodyArea,
  imgAlt,
  imgSrc,
  secondaryImgAlt,
  secondaryImgSrc,
  title,
}: IconCardProps) => {
  const generateImg = (imgSource: IconCardProps['imgSrc'], imageAlt: IconCardProps['imgAlt']) => {
    if (!imgSrc) {
      return null;
    }

    if (React.isValidElement(imgSource)) {
      return imgSource;
    }

    return (
      <img
        alt={imageAlt}
        height="84"
        loading="lazy"
        src={imgSrc as string}
        width="84"
      />
    );
  };

  return (
    <div className={styles.box}>
      <div className={styles.graphic}>
        {generateImg(imgSrc, imgAlt)}
        {secondaryImgAlt && generateImg(secondaryImgSrc, secondaryImgAlt)}
      </div>
      <div>
        <h4 className={styles.title}>{title}</h4>
        <div
          dangerouslySetInnerHTML={{ __html: contentBodyArea }}
          className={styles.chargesList}
        />
      </div>
    </div>
  );
};
